import { jsx as o } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import { UserImage as c } from "./user-image.js";
import { MenuItem as l } from "../menu-item/index.js";
const u = (t) => {
  const { isScrolledHeader: n, openAuthModal: r, getTranslation: a } = t;
  return /* @__PURE__ */ o(
    l,
    {
      label: a("pages.account"),
      chevronStyle: "no-rotate",
      hasShrunk: n,
      onClick: r,
      classNames: {
        wrapper: e.accountLinkWrapper,
        labelTitle: e.accountLabelTitle,
        chevronIcon: e.chevronIcon
      },
      icon: /* @__PURE__ */ o(c, {})
    }
  );
};
export {
  u as UnauthenticatedAccountLink
};
